import { useFetchService } from './fetchService';

export const useOrganization = (accessToken: string, shouldFetch = true) => {
  const { data: orgData, error: organizationError, mutate } = useFetchService(`/organizations/`, accessToken, shouldFetch);
  const isLoading = !orgData && !organizationError;
  return { orgData, organizationError, isLoading, mutate };
};
